import * as Yup from 'yup';
import { PartialInvoicingViewLineDto } from '~/types/internal-api';

export const validationSchema = (data: PartialInvoicingViewLineDto[]) => {
    const shape = {};

    data.forEach(line => {
        shape[`newQuantity-${line.lineId}`] = Yup.number()
            .min(0)
            .max(line.quantity - line.alreadyInvoiced, 'maxValueError');
    });

    return Yup.object().shape(shape);
};
